import get from "lodash/get";
import Lib from "./Lib";

export default function (obj, path, def = null) {
  return Lib.fillEmpty(get(obj, path, def), def);
}
